module.exports = __webpack_public_path__ + "media/images/city/086-white-house-27a5fa01e6f5ae903f7fa68b5a9be1b7.svg";